import type * as React from 'react';
import { Sheet, SheetContent } from '@/components/ui/sheet';

/**
 * Gaveta de filtros — sobe do RODAPÉ ocupando a largura toda (não é um Dialog central,
 * não é um Sheet lateral). Alça de 44×4px no topo, cantos 24px só em cima,
 * campos em grid auto-fit de 230px, ações alinhadas à direita.
 */
export const FilterSheet: React.FC<{
  open: boolean;
  onOpenChange: (v: boolean) => void;
  onClear?: () => void;
  onApply?: () => void;
  children: React.ReactNode;
}> = ({ open, onOpenChange, onClear, onApply, children }) => (
  <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetContent
      side="bottom"
      className="gap-5 rounded-t-[24px] border-x-0 border-b-0 border-t border-border bg-card p-6 px-5 pb-7 md:px-10"
    >
      <span className="mx-auto h-1 w-11 rounded-full bg-ring" />

      <div className="flex flex-wrap items-center gap-3">
        <span className="font-display mr-auto text-[19px] font-extrabold uppercase tracking-tight text-white">
          Filtros avançados
        </span>
        <button
          type="button"
          onClick={onClear}
          className="col-label cursor-pointer text-[11px] text-muted-foreground"
        >
          Limpar tudo
        </button>
      </div>

      <div className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,230px),1fr))] gap-3.5">
        {children}
      </div>

      <div className="flex flex-wrap items-center gap-2.5">
        <button
          type="button"
          onClick={() => onOpenChange(false)}
          className="ml-auto flex h-[46px] cursor-pointer items-center justify-center rounded-full border border-border px-[22px] text-[13.5px] font-semibold text-muted-foreground"
        >
          Fechar
        </button>
        <button
          type="button"
          onClick={onApply}
          className="flex h-[46px] cursor-pointer items-center justify-center rounded-full bg-sand px-7 text-[13.5px] font-bold text-on-sand hover:bg-sand-dim"
        >
          Aplicar filtros
        </button>
      </div>
    </SheetContent>
  </Sheet>
);
